import { OrganisationDto, type ParcelShop as ServicePointDto, UserType } from '@dhl/mdp-api'
import { getData } from '~/api/admin-api'
import { UUID } from '~/common/model'
import { getOrganisationUrl } from '~/modules/users/hooks/util'
import { ActiveKeysDto } from '~/modules/users/model/ActiveKeysDto'

export const getActiveApiKeys = (userId: UUID) => getData<ActiveKeysDto>(`organisation/user/${userId}/active-api-keys`)

export const getOrganisation = (userId: UUID, userType: UserType) => {
  const organisationUrl = getOrganisationUrl(userType)
  const endPart = organisationUrl.replace('parcel-shops', 'parcel-shop')
  return getData<OrganisationDto | ServicePointDto>(`users/${userId}/${endPart}`)
}
